import { debounceTime, distinctUntilChanged, map, OperatorFunction, pipe } from 'rxjs'

export const REMOTE_TEXT_SEARCH_DEBOUNCE_MS = 500
export const REMOTE_TEXT_SEARCH_MIN_LENGTH = 3

export interface RemoteTextSearchPolicyOptions {
	minLength?: number
	allowShortSearch?: (normalizedTerm: string) => boolean
}

export const normalizeRemoteTextSearchTerm = (value: unknown): string => String(value ?? '').trim()

export const debounceDistinctTextSearch = (
	debounceMs: number = REMOTE_TEXT_SEARCH_DEBOUNCE_MS
): OperatorFunction<unknown, string> =>
	pipe(map(normalizeRemoteTextSearchTerm), debounceTime(debounceMs), distinctUntilChanged())

export const hasRemoteTextSearchMinLength = (
	value: string | null | undefined,
	minLength = REMOTE_TEXT_SEARCH_MIN_LENGTH
): boolean => normalizeRemoteTextSearchTerm(value).length >= minLength

export const canExecuteRemoteTextSearch = (
	value: string | null | undefined,
	options: RemoteTextSearchPolicyOptions = {}
): boolean => {
	const normalizedTerm = normalizeRemoteTextSearchTerm(value)
	if (!normalizedTerm) return false

	if (options.allowShortSearch?.(normalizedTerm)) {
		return true
	}

	return hasRemoteTextSearchMinLength(normalizedTerm, options.minLength)
}

export const normalizeRemoteSearchStringParam = (
	value: string | null | undefined,
	options: RemoteTextSearchPolicyOptions = {}
): string | undefined => {
	const normalizedTerm = normalizeRemoteTextSearchTerm(value)
	return canExecuteRemoteTextSearch(normalizedTerm, options) ? normalizedTerm : undefined
}
